export const blockIconsMapsWarehouseNew = (
	<span className='material-symbols-outlined'>warehouse</span>
);
